import React, { useEffect, useState } from "react";
import { BsFillGearFill } from "react-icons/bs";
import { MdRefresh } from "react-icons/md";
import { BiTask } from "react-icons/bi";
import { RiMenuFoldLine } from "react-icons/ri";
import { IoMdStopwatch } from "react-icons/io";

import { Container, ControlsContainer, Backdrop } from "./styles";
import Range from "./Range";
import Toggle from "./Toggle";
import logo from "../../assets/logo.png";

function Controls({
  currentSize,
  clearGrid,
  showCorrectNumbers,
  setShowCorrectNumbers,
  showMistakes,
  setShowMistakes,
  expanded,
  setExpanded,
  time,
  showGuide,
  showTimes,
}) {
  const [size, setSize] = useState(5);

  useEffect(() => {
    if (currentSize) setSize(currentSize);
  }, [currentSize]);

  return (
    <Container>
      <button
        className="toggle-controls side-button"
        onClick={() => setExpanded(true)}
      >
        <BsFillGearFill />
        <span>Configurações</span>
      </button>
      <button className="toggle-help side-button" onClick={() => showGuide()}>
        <BiTask />
        <span>Como Completar</span>
      </button>
      <button
        className="toggle-history side-button"
        onClick={() => showTimes()}
      >
        <IoMdStopwatch />
        <span>Tempos</span>
      </button>
      <ControlsContainer expanded={expanded}>
        <div className="header">
          <img src={logo} alt="" srcSet="" className="logo" />
          <button className="close" onClick={() => setExpanded(false)}>
            <RiMenuFoldLine />
          </button>
        </div>
        <div className="size-controller">
          <p>Tamanho do Tabuleiro</p>
          <div className="range">
            <Range
              min="1"
              max="10"
              value={size ? size : 5}
              onChange={event => setSize(event.target.value)}
              onMouseUp={() => clearGrid(size * 10)}
            />
            <span>{size * 10}</span>
          </div>
          {/* <button onClick={() => clearGrid(size * 10)}>Alterar tamanho</button> */}
        </div>
        <div className="toggle">
          <span>Exibir o número correto para cada posição</span>
          <Toggle
            value={showCorrectNumbers}
            setValue={value => setShowCorrectNumbers(value)}
          />
        </div>
        <div className="toggle">
          <span>Destacar números posicionados incorretamente</span>
          <Toggle
            value={showMistakes}
            setValue={value => setShowMistakes(value)}
          />
        </div>
        <div className="bottom">
          {time && <span className="time">Tempo: {time}</span>}
          <button
            onClick={() => {
              clearGrid();
              setExpanded(false);
            }}
          >
            <MdRefresh /> Reiniciar
          </button>
        </div>
      </ControlsContainer>
      {expanded && (
        <Backdrop expanded={expanded} onClick={() => setExpanded(false)} />
      )}
    </Container>
  );
}

export default Controls;
